export default "__VITE_ASSET__CQwi1EKJ__"